import {useEffect, useMemo, useState} from "react";
import {InputText} from "../../component/form/InputText";
import {BreadCrumb} from "../../component/Breadcrumb";
import {Button} from "../../component/form/Button";
import {SelectReact} from "../../component/form/SelectReact";
import {showError} from "../../js/main";
import {DiscountRangeEditor} from "./DiscountRangeEditor";
import {deriveDiscountEntries, prepareDiscountForSubmit, validateDiscountInfo} from "./discountUtil";

export const Edit = ({initialDiscountInfo, keys = [], saveAction, submitting, setSubmitting}) => {

    const [discountInfo, setDiscountInfo] = useState(normalizeDiscountInfo(initialDiscountInfo));

    useEffect(() => {
        setDiscountInfo(normalizeDiscountInfo(initialDiscountInfo));
    }, [initialDiscountInfo]);

    const keyOptions = useMemo(() => keys.map(key => ({
        value: key.id,
        label: `${key.itemNo ? key.itemNo + " " : ""}${key.title}`
    })), [keys]);

    const handleChange = (newValue, field) => {
        setDiscountInfo(currentInfo => ({
            ...currentInfo,
            [field]: newValue
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const validationMessage = validateDiscountInfo(discountInfo);
        if (validationMessage) {
            showError(validationMessage);
            return;
        }

        setSubmitting(true);
        saveAction(prepareDiscountForSubmit(discountInfo)).finally(() => {
            setSubmitting(false);
        });
    };

    return (
        <div>
            <BreadCrumb currentTitle={"Rabatt " + (discountInfo.id === null ? "hinzufügen" : "bearbeiten")}
                        parentTitle="Rabatte"
                        parentLink="/rabatte"/>

            <form onSubmit={handleSubmit}>
                <div className="default mb-2">
                    <InputText name="title" value={discountInfo.title} label="Titel" setter={handleChange} required/>
                    <SelectReact name="keyIds"
                                 label="Schlüssel"
                                 value={discountInfo.keyIds || []}
                                 options={keyOptions}
                                 setter={handleChange}
                                 isMulti/>
                </div>

                <DiscountRangeEditor entries={discountInfo.entries} setter={handleChange}/>

                <div className="safe-actions mt-1">
                    <Button key="back"
                            theme="secondary-button mr-1 mb-1"
                            width={230}
                            submitting={submitting}
                            onClick={e => {
                                e.preventDefault();
                                window.history.back();
                            }}>zurück</Button>
                    <Button key="submit" theme="primary-button mb-1" width={230} submitting={submitting}>speichern</Button>
                </div>
            </form>
        </div>
    );
};

const normalizeDiscountInfo = (discountInfo) => ({
    ...discountInfo,
    title: discountInfo.title || "",
    keyIds: discountInfo.keyIds || [],
    entries: deriveDiscountEntries(discountInfo.entries)
});
